"use strict";
"use client";

var _excluded = ["__scopeSwitch", "name", "checked", "defaultChecked", "required", "disabled", "value", "onCheckedChange", "form"],
  _excluded2 = ["__scopeSwitch"],
  _excluded3 = ["control", "checked", "bubbles"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// packages/react/switch/src/index.ts
var src_exports = {};
__export(src_exports, {
  Root: function Root() {
    return _Root;
  },
  Switch: function Switch() {
    return _Switch;
  },
  SwitchThumb: function SwitchThumb() {
    return _SwitchThumb;
  },
  Thumb: function Thumb() {
    return _Thumb;
  },
  createSwitchScope: function createSwitchScope() {
    return _createSwitchScope;
  }
});
module.exports = __toCommonJS(src_exports);

// packages/react/switch/src/Switch.tsx
var React = __toESM(require("react"));
var import_primitive = require("@radix-ui/primitive");
var import_react_compose_refs = require("@radix-ui/react-compose-refs");
var import_react_context = require("@radix-ui/react-context");
var import_react_use_controllable_state = require("@radix-ui/react-use-controllable-state");
var import_react_use_previous = require("@radix-ui/react-use-previous");
var import_react_use_size = require("@radix-ui/react-use-size");
var import_react_primitive = require("@radix-ui/react-primitive");
var import_jsx_runtime = require("react/jsx-runtime");
var SWITCH_NAME = "Switch";
var _ref = (0, import_react_context.createContextScope)(SWITCH_NAME),
  _ref2 = _slicedToArray(_ref, 2),
  createSwitchContext = _ref2[0],
  _createSwitchScope = _ref2[1];
var _createSwitchContext = createSwitchContext(SWITCH_NAME),
  _createSwitchContext2 = _slicedToArray(_createSwitchContext, 2),
  SwitchProvider = _createSwitchContext2[0],
  useSwitchContext = _createSwitchContext2[1];
var _Switch = React.forwardRef(function (props, forwardedRef) {
  var __scopeSwitch = props.__scopeSwitch,
    name = props.name,
    checkedProp = props.checked,
    defaultChecked = props.defaultChecked,
    required = props.required,
    disabled = props.disabled,
    _props$value = props.value,
    value = _props$value === void 0 ? "on" : _props$value,
    onCheckedChange = props.onCheckedChange,
    form = props.form,
    switchProps = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    button = _React$useState2[0],
    setButton = _React$useState2[1];
  var composedRefs = (0, import_react_compose_refs.useComposedRefs)(forwardedRef, function (node) {
    return setButton(node);
  });
  var hasConsumerStoppedPropagationRef = React.useRef(false);
  var isFormControl = button ? form || !!button.closest("form") : true;
  var _ref3 = (0, import_react_use_controllable_state.useControllableState)({
      prop: checkedProp,
      defaultProp: defaultChecked,
      onChange: onCheckedChange
    }),
    _ref4 = _slicedToArray(_ref3, 2),
    _ref4$ = _ref4[0],
    checked = _ref4$ === void 0 ? false : _ref4$,
    setChecked = _ref4[1];
  return /* @__PURE__ */(0, import_jsx_runtime.jsxs)(SwitchProvider, {
    scope: __scopeSwitch,
    checked: checked,
    disabled: disabled,
    children: [/* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_primitive.Primitive.button, _objectSpread(_objectSpread({
      type: "button",
      role: "switch",
      "aria-checked": checked,
      "aria-required": required,
      "data-state": getState(checked),
      "data-disabled": disabled ? "" : void 0,
      disabled: disabled,
      value: value
    }, switchProps), {}, {
      ref: composedRefs,
      onClick: (0, import_primitive.composeEventHandlers)(props.onClick, function (event) {
        setChecked(function (prevChecked) {
          return !prevChecked;
        });
        if (isFormControl) {
          hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
          if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
        }
      })
    })), isFormControl && /* @__PURE__ */(0, import_jsx_runtime.jsx)(BubbleInput, {
      control: button,
      bubbles: !hasConsumerStoppedPropagationRef.current,
      name: name,
      value: value,
      checked: checked,
      required: required,
      disabled: disabled,
      form: form,
      style: {
        transform: "translateX(-100%)"
      }
    })]
  });
});
_Switch.displayName = SWITCH_NAME;
var THUMB_NAME = "SwitchThumb";
var _SwitchThumb = React.forwardRef(function (props, forwardedRef) {
  var __scopeSwitch = props.__scopeSwitch,
    thumbProps = _objectWithoutProperties(props, _excluded2);
  var context = useSwitchContext(THUMB_NAME, __scopeSwitch);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_primitive.Primitive.span, _objectSpread(_objectSpread({
    "data-state": getState(context.checked),
    "data-disabled": context.disabled ? "" : void 0
  }, thumbProps), {}, {
    ref: forwardedRef
  }));
});
_SwitchThumb.displayName = THUMB_NAME;
var BubbleInput = function BubbleInput(props) {
  var control = props.control,
    checked = props.checked,
    _props$bubbles = props.bubbles,
    bubbles = _props$bubbles === void 0 ? true : _props$bubbles,
    inputProps = _objectWithoutProperties(props, _excluded3);
  var ref = React.useRef(null);
  var prevChecked = (0, import_react_use_previous.usePrevious)(checked);
  var controlSize = (0, import_react_use_size.useSize)(control);
  React.useEffect(function () {
    var input = ref.current;
    var inputProto = window.HTMLInputElement.prototype;
    var descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
    var setChecked = descriptor.set;
    if (prevChecked !== checked && setChecked) {
      var event = new Event("click", {
        bubbles: bubbles
      });
      setChecked.call(input, checked);
      input.dispatchEvent(event);
    }
  }, [prevChecked, checked, bubbles]);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)("input", _objectSpread(_objectSpread({
    type: "checkbox",
    "aria-hidden": true,
    defaultChecked: checked
  }, inputProps), {}, {
    tabIndex: -1,
    ref: ref,
    style: _objectSpread(_objectSpread(_objectSpread({}, props.style), controlSize), {}, {
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    })
  }));
};
function getState(checked) {
  return checked ? "checked" : "unchecked";
}
var _Root = _Switch;
var _Thumb = _SwitchThumb;